import React, { useEffect, useState } from 'react'
import SuperSearchMultiple from '../../../shared/SuperSearch/SuperSearchMultiple'
import { Modal } from "react-bootstrap";
import { enumUtil } from '../../../../utils/Enum';
import isNull from '../../../../utils/NullChecking';
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../utils/NotificationHandler';
import SuperSearchMultipleClient from '../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient';
import Loader from "../../../shared/Loader/Loader"
const AddNewCounty = (props) => {
    const { isOpenCounty, onCloseCounty, LocationID, InsuranceID, ProgramTypeDD, selectedCounties, countyID } = { ...props }
    const API_URL = enumUtil.controller.ProviderFeeSchedule
    const [countyMasterList, setCountyMasterList] = useState([])
    const [selectedMasterListCounties, setSelectedMasterListCounties] = useState([])
    let data = {
        CountyName: "",
        ProgramType: ""
    }
    const [searchParam, setSearchParam] = useState(data);
    const [isLoading, setIsLoading] = useState(false)
    const LoadMasterList = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/GetMasterListCounty", 'post', {
            "TableName": enumUtil.enumAPITableName.CountyMasterList,
            "ID": LocationID + "",
            "SearchParam": ""
        }).then((response) => {
            setIsLoading(false)
            setCountyMasterList(response)
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
    useEffect(() => {
        if (!isNull(LocationID)) {
            LoadMasterList()
        }
    }, [])
    useEffect(() => {
        if (countyID > 0) {
            let initialSelectedCounties = []
            if (selectedCounties.length > 0) {
                selectedCounties[0].display.split(',').map((item) => {
                    initialSelectedCounties.push({ value: item.trim(' '), display: item.trim(' ') })
                })
                setSelectedMasterListCounties(initialSelectedCounties)
            }
        }
    }, [selectedCounties])
    const SaveSelecctedCounties = () => {
        const result = ProgramTypeDD.map(item => item.value).join(', ');

        if (countyID === 0 && searchParam.CountyName === '') {
            NotificationHandler('Cannot save empty county', enumUtil.enumtoaster.error)
        } else {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveFeeSetupCounty", 'post', {
                "TableName": enumUtil.enumAPITableName.FeeSetupCounty,
                "ID": countyID,
                "Data": {
                    "InsuranceID": InsuranceID + "",
                    "LocationID": LocationID + "",
                    "CountyName": !isNull(searchParam.CountyName) ? searchParam.CountyName : selectedCounties[0].display,
                    "ProgramType": !isNull(searchParam.ProgramType) ? searchParam.ProgramType : result,
                    "OldCountyName": !isNull(selectedCounties[0]) ? selectedCounties[0].display : ''
                }
            }).then((response) => {
                setIsLoading(false)
                NotificationHandler('Record Saved Successfully', enumUtil.enumtoaster.success)
                onCloseCounty()
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }

    }
    const handleAddNewCounty = (value) => {
        if (value !== "") {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveCountyMasterList", 'post', {
                "TableName": enumUtil.enumAPITableName.CountyMasterList,
                "ID": 0,
                "Data": {
                    "LocationID": LocationID + "",
                    "CountyName": value,
                }
            }).then((response) => {
                LoadMasterList()
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }

    }
    return (
        <Modal show={isOpenCounty} onHide={isOpenCounty} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 za-county-popup">
            <Modal.Body>
                {isLoading ? <Loader /> : null}
                <div className='d-flex justify-content-between align-items-center mb-10'>
                    <p className='heading fs-14 dark-clr'>{!isNull(searchParam.CountyName) ? searchParam.CountyName : 'Add County'}</p>
                    <div className='d-flex'>
                        <i className='icon-x-cros fs-20' onClick={onCloseCounty}></i>
                    </div>
                </div>
                <div className="hk-table-flex">
                    <div className='input form-group'>
                        <div className="align-items-center label-head  d-flex justify-content-between mb-1">
                            <label htmlFor="">Program Type
                                {/* <span className='req'>*</span> */}
                            </label>
                        </div>
                        <div className='input form-group'>
                            <SuperSearchMultipleClient
                                key={`${ProgramTypeDD}-${ProgramTypeDD?.length}`}
                                id="ProgramType"
                                name="ProgramType"
                                selectedOptionsDisplay='Program Type'
                                initialSelectedValues={ProgramTypeDD}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                options={ProgramTypeDD}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                    </div>
                    <div className='input form-group'>
                        <label htmlFor="">County</label>
                        <SuperSearchMultipleClient
                            key={`${countyMasterList}-${selectedMasterListCounties}-${selectedCounties}`}
                            id="CountyName"
                            name="CountyName"
                            selectedOptionsDisplay='County'
                            initialSelectedValues={selectedMasterListCounties}
                            searchParam={searchParam}
                            setSearchParam={setSearchParam}
                            options={countyMasterList}
                            sup_btn="sup_btn-Inp"
                            sup_inp="superSearchVisitInp"
                            AddNew={true}
                            handleAddNew={handleAddNewCounty}
                            isOpenList={true}
                        />
                    </div>

                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className="btn btn-validate px-10 h-100" onClick={SaveSelecctedCounties}>Save </button>
            </div>

        </Modal>
    )
}

export default AddNewCounty